// const NewsData = [
// 	{
// 		id: 1,
// 		image: "https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		topic: "Transportation",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage:
// 			"https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 2,
// 		image: "https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		topic: "Transportation",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage:
// 			"https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 3,
// 		image: "https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		topic: "Transportation",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage:
// 			"https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 4,
// 		image: "https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		topic: "Transportation",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage:
// 			"https://www.solidbackgrounds.com/images/3840x2160/3840x2160-light-gray-solid-color-background.jpg",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 5,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Transportation",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 6,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Shopping",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 7,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Shopping",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 8,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Shopping",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 9,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Eating",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 10,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Shopping",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 11,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Eating",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 12,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Eating",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 13,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Eating",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 14,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Eating",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},

// 	{
// 		id: 15,
// 		image: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		topic: "Eating",
// 		title: "Electric Cars is the trend for a grenner life",
// 		description:
// 			"Lorem ipsum dolor sit amet consectetur. Auctor praesent lectus consequat etiam venenatis sapien turpis nisi et. Lorem ipsum dolor sit amet consectetur.",
// 		userImage: "https://images3.alphacoders.com/113/thumb-1920-1135880.png",
// 		userName: "RMIT Education",
// 	},
// ];

// export default NewsData;

import axios from "axios";
const API_KEY = "ccdf2d576ae44d91b7ea44c94bccb8ed";
const BASE_URL = "https://newsapi.org/v2";
const categories = ["business", "health", "sports"];

// Create an axios instance configured with your API key and base URL
const api = axios.create({
	baseURL: BASE_URL,
	params: { apiKey: API_KEY, language: "en" },
});

const fetchNewsByCategory = async (category) => {
	try {
		if (category === "All") {
			const promises = categories.map((cat) =>
				api.get("/top-headlines", { params: { category: cat } }),
			);
			const responses = await Promise.all(promises);
			return responses.flatMap((response) => response.data.articles);
		} else {
			const response = await api.get("/top-headlines", {
				params: { category },
			});
			return response.data.articles;
		}
	} catch (error) {
		console.error(`Error fetching news for category ${category}:`, error);
		throw error;
	}
};

export default fetchNewsByCategory;
